<template>
  <v-text-field
    type="text"
    :class="`ep-textfield-${valid ? 'valid' : 'invalid'}`"
    :style="{
      height: '50px',
      background: '#FFFFFF',
      border: '1px solid #E0E0E0',
      borderRadius: '8px',
      boxShadow: 'none'
    }"
    :tabindex="field.tabIndex"
    :required="field.required"
    :loading="field.loading"
    :hint="field.hint"
    :persistent-hint="!!field.hint"
    :value="value"
    @input="value => $emit('input', value)"
    v-mask="field.mask"
    v-bind="$attrs"
    v-on="$listeners"
    solo
  ></v-text-field>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "TextField",

  props: ["field", "value", "valid"],

  mounted() {
    // console.log(this.$attrs);
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss">
.ep-textfield-invalid {
  background: #ffafaf 0% 0% no-repeat padding-box !important;
  border: 1px solid #ff0000 !important;

  .v-input__slot {
    background: #ffafaf 0% 0% no-repeat padding-box !important;
    border: transparent;
    border-radius: 8px;
  }
}
</style>
